export default __webpack_public_path__ + "static/media/ae.a9f6b270.svg";